import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Form from 'component/utils/Form'
import Field from 'component/utils/Field'
import DatePicker from 'component/utils/DatePicker'
import CompanySelect from 'component/branch/CompanySelect'

class SalesCoachingFilterForm extends Component {
  handleSubmit = (event) => {
    event.preventDefault()

    const { values, fetchReports } = this.props

    const filters = {
      ...values,
      dtStart: values.dtStart
        ? moment(values.dtStart).format('DD/MM/YYYY')
        : null,
      dtEnd: values.dtEnd ? moment(values.dtEnd).format('DD/MM/YYYY') : null,
    }

    fetchReports(filters)
  }

  clearFields = () => {
    const { fields, setValueToField } = this.props

    Object.keys(fields).forEach((field) => {
      setValueToField(field, '')
    })
  }

  render() {
    const { translate, fields, setValueToField, user } = this.props

    return (
      <form className='SalesCoachingFilterForm'>
        <fieldset>
          <Row>
            <Col xs={12}>
              <h3>{translate('salesCoaching.completeReport')}</h3>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <Field
                {...fields.idBranch}
                error={translate(fields.idBranch.error)}
              >
                <CompanySelect {...fields.idBranch.input} user={user} />
              </Field>
            </Col>
          </Row>

          <Row>
            <Col xs={6}>
              <div className='field'>
                <Field
                  {...fields.dtStart}
                  error={translate(fields.dtStart.error)}
                  glyph='glyph glyph-calendar'
                >
                  <DatePicker
                    date={fields.dtStart.input.value}
                    onDateChange={(date) => setValueToField('dtStart', date)}
                    placeholder={translate('salesCoaching.startDate')}
                    isOutsideRange
                  />
                </Field>
              </div>
            </Col>

            <Col xs={6}>
              <div className='field'>
                <Field
                  {...fields.dtEnd}
                  error={translate(fields.dtEnd.error)}
                  glyph='glyph glyph-calendar'
                >
                  <DatePicker
                    date={fields.dtEnd.input.value}
                    onDateChange={(date) => setValueToField('dtEnd', date)}
                    placeholder={translate('salesCoaching.endDate')}
                    isOutsideRange
                  />
                </Field>
              </div>
            </Col>
          </Row>
        </fieldset>

        <Row className='margin-top-double margin-bottom'>
          <Col xs={12}>
            <button
              role='button'
              type='button'
              onClick={this.handleSubmit}
              className='button button-primary button-full'
            >
              {translate('salesCoaching.download')}
            </button>
          </Col>
        </Row>
      </form>
    )
  }
}

SalesCoachingFilterForm.propTypes = {
  fields: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  fetchReports: PropTypes.func.isRequired,
  setValueToField: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
}

const fields = ['idBranch', 'dtStart', 'dtEnd']

export default Form({ fields })(SalesCoachingFilterForm)

export { SalesCoachingFilterForm }
